import { useState } from 'react'
import {
  Button,
  Heading,
  Text,
  Card,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Tooltip,
  Box,
  Stack,
} from '@chakra-ui/react'

import { DeleteButtonWithPermission } from 'components'
import { SERVICE_PROFILE_PERMISSIONS } from 'ServicesLetter/views/ServiceProfile/constants'
import { useCustomFormBuilder } from '../../contexts/CustomFormBuilderManagerContext/Provider'

const DeleteCustomFormCard = () => {
  const [loadingButton, setLoadingButton] = useState(false)

  const { isOpen, onClose, onOpen } = useDisclosure()

  const { isFormActionsDisabled, deleteForm } = useCustomFormBuilder()

  async function handleDeleteActivityTypeCustomForm() {
    setLoadingButton(true)
    const response = await deleteForm()
    setLoadingButton(false)
    return response
  }

  return (
    <>
      <Card borderWidth="1px" borderColor="borderColor">
        <Stack>
          <Text>Deletar formulário </Text>
          <Text variant="secondary">Uma vez que o formulário seja deletado, você não terá mais acesso ao mesmo</Text>

          {isFormActionsDisabled ? (
            <Tooltip label="Este formulário é restrito, não pode ser alterado / deletado.">
              <Box>
                <DeleteButtonWithPermission width="100%" isDisabled variant="outline" colorScheme="red">
                  Deletar formulário
                </DeleteButtonWithPermission>
              </Box>
            </Tooltip>
          ) : (
            <DeleteButtonWithPermission
              permissions={[SERVICE_PROFILE_PERMISSIONS.DELETE_CUSTOM_FORM]}
              onClick={onOpen}
              variant="outline"
              colorScheme="red"
            >
              Deletar formulário
            </DeleteButtonWithPermission>
          )}
        </Stack>
      </Card>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent>
          <ModalCloseButton />
          <ModalHeader>
            <Heading>Deseja deletar a formulário ?</Heading>
          </ModalHeader>

          <ModalBody>
            <Text>Uma vez que o formulário seja deletado, você não terá mais acesso ao mesmo</Text>
          </ModalBody>

          <ModalFooter>
            <Button variant="outline" onClick={onClose}>
              Fechar
            </Button>
            <Button isLoading={loadingButton} onClick={handleDeleteActivityTypeCustomForm} colorScheme="red">
              Sim, tenho certeza
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default DeleteCustomFormCard
